import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import fetchCreator from './fetch-creator'
import fetchTags from './fetch-tags'
import fetchReferences from './fetch-references'
import fetchReactions from './fetch-reactions'

export default async function setMeta(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    // statementStore.commitInitMeta({ statementId: statement.id })
    fetchCreator(context, statement)
    fetchReactions(context, statement)
    fetchReferences(context, statement)
    fetchTags(context, statement)
    statement.isMetaSet = true
    return
}
